import { Component } from '@angular/core';
import { SelectSnapshot } from '@ngxs-labs/select-snapshot';
import { Store } from '@ngxs/store';
import { Toast, ToastPackage, ToastrService } from 'ngx-toastr';
import { WellKnownIconsEnum } from 'src/app/helper/iconHelper';
import { MessageInfo } from 'src/app/store/samwin/samwin-mail-list/message-info';
import { OpenMessage } from 'src/app/store/samwin/samwin-mail-list/samwin-message-list.actions';
import { SamwinMessageLinesStateSelectors } from 'src/app/store/samwin/samwin-message-lines/samwin-message-lines.selectors';
import { flyInOut } from '../../utility/animation/animations';

@Component({
   selector: 'samweb-assigned-mail-toast',
   templateUrl: './assigned-mail-toast.component.html',
   styleUrls: ['./assigned-mail-toast.component.scss'],
   animations: [flyInOut],
})
export class AssignedMailToastComponent extends Toast {
   @SelectSnapshot(SamwinMessageLinesStateSelectors.getCurrentAssignedMessage)
   public currentAssignedMail: MessageInfo;

   public openMessageIcon = WellKnownIconsEnum.EMAILING_OPEN_MESSAGE.icon;

   constructor(protected toastrService: ToastrService, public toastPackage: ToastPackage, public store: Store) {
      super(toastrService, toastPackage);
   }

   openMail() {
      this.store.dispatch(new OpenMessage(this.currentAssignedMail.callId, this.currentAssignedMail.messageId));
   }
}
